export const contractErrorMessages = ['Not a crucible address'];
